import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { reduce } from 'lodash'

import { landAxios } from '@Root/utils/landAxios'
import { FETCH_STATUS } from '@Root/contants'
import ComplexPyeongDetail from '@Types/entities/ComplexPyeongDetail'

export const fetchManagementFee = createAsyncThunk(
  'myhouse/fetchManagementFee',
  async (complexNo: number) =>
    await (
      await landAxios.get(`/complexes/${complexNo}`, {
        params: {
          sameAddressGroup: false,
        },
      })
    ).data,
)
export type MyhouseManagementFeeState = {
  pyeongNo: string
  isExistMaintenanceFee: boolean
  complexPyeongDetailList: ComplexPyeongDetail[]
  complexPyeongDetailMap: {
    [pyeongNo: string]: ComplexPyeongDetail
  }
  fetchStatus: FETCH_STATUS
}

export const initialState: MyhouseManagementFeeState = {
  pyeongNo: '',
  isExistMaintenanceFee: false,
  complexPyeongDetailList: [],
  complexPyeongDetailMap: {},
  fetchStatus: FETCH_STATUS.INITIAL,
} as MyhouseManagementFeeState

export const myhouseManagementFeeSlice = createSlice({
  name: 'myhouseManagementFeeSlice',
  initialState,
  reducers: {
    initializeState: (state: MyhouseManagementFeeState) => {
      Object.assign(state, initialState)
    },
    updatePyeongNo: (state: MyhouseManagementFeeState, action: PayloadAction<string>) => {
      state.pyeongNo = action.payload
    },
  },

  extraReducers: {
    [fetchManagementFee.fulfilled.type]: (state: MyhouseManagementFeeState, action: PayloadAction<{ complexPyeongDetailList: ComplexPyeongDetail[] }>) => {
      const complexPyeongDetailList = action.payload?.complexPyeongDetailList || []
      const complexPyeongDetailMap = reduce(
        complexPyeongDetailList,
        (
          complexPyeongDetailMap: {
            [pyeongNo: string]: ComplexPyeongDetail
          },
          complexPyeongDetail: ComplexPyeongDetail,
        ) => {
          complexPyeongDetailMap[complexPyeongDetail.pyeongNo] = complexPyeongDetail
          return complexPyeongDetailMap
        },
        {},
      )
      const isExistMaintenanceFee = complexPyeongDetailList.filter((complexPyeongDetail: ComplexPyeongDetail) => complexPyeongDetail.averageMaintenanceCost).length > 0

      Object.assign(state, {
        pyeongNo: complexPyeongDetailList?.[0].pyeongNo || '0',
        complexPyeongDetailList,
        complexPyeongDetailMap,
        isExistMaintenanceFee,
        fetchStatus: FETCH_STATUS.SUCCESS,
      })
    },
    [fetchManagementFee.pending.type]: (state: MyhouseManagementFeeState) => {
      state.fetchStatus = FETCH_STATUS.PENDING
    },
    [fetchManagementFee.rejected.type]: (state: MyhouseManagementFeeState) => {
      state.fetchStatus = FETCH_STATUS.FAILURE
    },
  },
})

export const { initializeState, updatePyeongNo } = myhouseManagementFeeSlice.actions

export default myhouseManagementFeeSlice.reducer
